import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'americanDateTimeFormat'
})
export class AmericanDatetimeFormatPipe implements PipeTransform {

  transform(dateString?: string): string {
    if (!dateString) {
      return '';
    }
    const [datePart, timePart] = dateString.split(' '); // Split date and time
    const [month, day, year] = datePart.split('/').map(Number);
    let [hours, minutes, seconds] = timePart.split(':').map(Number);

    // Convert to 12-hour format
    const period = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12; // Convert 0 or 12 to 12

    return `${month}-${day}-${year} ${hours}:${minutes.toString().padStart(2, '0')}${period}`;
  }
  

}
